/** ************************************************************************
 * Atomic Component for the bPerx iFrame UI.
 *
 * Atomic Type: Content, dynamic (content that changes with state)
 * Purpose: Display the image of the chosen product
 *
 * @file   Atomic Component, content dynamic, chosen magazine image
 * @author Paul J Stales
 * @since  2.2.0
 ************************************************************************ */

import { FunctionalComponent, h } from 'preact'
import { css } from 'aphrodite'
import { IFRAME_CLASSNAMES } from '../../../../../../common/constants/ConstantsIFrameClassNames'

/**
 * Props Interface for Chosen Magazine Image
 */
interface ChosenMagazineImageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  styles: { [key: string]: any }
  coverImageURL?: string
  description?: string
}

/**
 * ChosenMagazineImage displays the currently selected magazine.
 * @param ChosenMagazineImageProps
 * @returns
 */
const ChosenMagazineImage: FunctionalComponent<ChosenMagazineImageProps> = ({
  styles,
  coverImageURL,
  description
}) => {
  return (
    <img
      class={`${IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_IMAGE}${' '}${
        styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_IMAGE] === undefined
          ? ''
          : css(styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_IMAGE])
      }`}
      src={coverImageURL}
      alt={description}
    />
  )
}

export default ChosenMagazineImage
